import Select from '@components/elements/Form/Select';

import LanguageOptionLabel from './LanguageOptionLabel';
import withLanguageSelector from './withLanguageSelector';

const LanguageSelector = ({
  languages,
  language,
  changeLanguage,
  customStyles,
  menuPlacement,
  menuPortalTarget,
}) => (
  <Select
    options={languages}
    value={language}
    getOptionLabel={LanguageOptionLabel}
    onChange={changeLanguage}
    styles={customStyles}
    isSearchable={false}
    name="language"
    menuPlacement={menuPlacement}
    menuPortalTarget={menuPortalTarget}
  />
);

LanguageSelector.displayName = 'LanguageSelector';

export default withLanguageSelector(LanguageSelector);
